import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./email-list-cleaning.component').then(m => m.EmailListCleaningComponent),
        data: {
          title: 'Email Validation Service to Clean and Score Lists | KudosHub',
          description:'KudosHub’s email validation service helps clean and score lists, reduce bounce rate, and protect email reputation. Try it free with 3,000 validations.',
          keywords: 'email validation service, email scrubbing, email verification, eliminate invalid, spam traps, abusive, catch-all, disposable, toxic and role-based emails, 99% accuracy',
          ogTitle: 'Email Validation Service to Clean and Score Lists | KudosHub',
          ogDesc: 'KudosHub’s email validation service helps clean and score lists, reduce bounce rate, and protect email reputation. Try it free with 3,000 validations.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/email-validation-service.webp',
          ogUrl: 'https://kudoshub.com/email-validation',
          twitterTitle: 'Email Validation Service to Clean and Score Lists | KudosHub',
          twitterDesc: 'KudosHub’s email validation service helps clean and score lists, reduce bounce rate, and protect email reputation. Try it free with 3,000 validations.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/email-validation-service.webp',
          dateModified: '2025-09-09T19:00:00+05:30'
        }
      }
    ]
  }
];
